/**
 * Site-wide footer component.
 * @module src/App/Footer
 */

import React from 'react';
import { Link } from 'react-router-dom';

import routeConfig from 'src/routeConfig';
import * as styles from './index.less';

/**
 * Footer React component.
 * @returns {React.ReactElement} The component's elements.
 */
export default function Footer() {
    const { children: routeChildren } = routeConfig;
    const keys = Object.keys(routeChildren).sort(
        (a, b) => routeChildren[a].rank - routeChildren[b].rank,
    );
    const links = keys.map((name) => {
        const { isHidden, title, path } = routeChildren[name];
        if (isHidden) {
            return null;
        }
        return <Link key={path} to={path}>{title}</Link>;
    });

    const { title, path } = routeConfig;

    return (
        <footer className={styles.footer}>
            <nav>
                <div className={styles.left}>
                    <Link to={path}>{title}</Link>
                    {links}
                </div>
            </nav>
        </footer>
    );
}
